export default "__VITE_ASSET__DJOwIYxm__"